export default __webpack_public_path__ + "static/media/raids.45552e71.png";